import React from 'react'
import { IconWrapper } from './Icon.styles'

const Icon: React.FC = ({ children }) => <IconWrapper>{children}</IconWrapper>

export default Icon
